import React, { useState } from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Typography from "@material-ui/core/Typography/Typography";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { BrowserRouter as Router, useHistory, useLocation } from "react-router-dom"
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme) => {
    return {
        root: {
            margin: '0 20px'
        },
        content: {
            paddingBottom: 0
        },
        about: {
            fontSize: '0.9rem',
            marginLeft: 20
        },
        comment: {
            fontSize: '0.8rem',
        },
    }});

export default function Links(props) {

    const classes = useStyles();
    const history = useHistory();

    const displayMax = 155;

    return <div className={classes.root}>
            <Typography variant="body2" component="p" className={classes.comment}>
                {<List component="nav" aria-label="secondary mailbox folder">

                {props.links && props.links.map((item, index) => {
                    return <a href={item.value}><ListItem
                        button
                    >
                        <ListItemText primary={<a href={item.value}>{item.name}</a>} />
                    </ListItem></a>
                })}
                </List>}
            </Typography>
        </div>;
}
